// Field errors arrive either as translation keys from the validation schemas
// (for example "auth.validation.passwordRequired") or as literal text, such as
// a message copied from an API response. Look the key up, but fall back to the
// original text so a literal message is never swallowed or cut at a ":" or "."
// that i18next would otherwise read as a namespace or key separator.
export const resolveFieldError = (t, error) => {
  if (typeof error !== "string") return error;
  if (typeof t !== "function") return error;
  return t(error, { defaultValue: error });
};
